// extracted by mini-css-extract-plugin
export default {"label":"Label_label__+y37G","required":"Label_required__kK+e+"};